<ng-container *ngIf="field">
	<div class="flex-auto input-field-container {{ field.customClass }}">
		<label [hidden]="field.UIOptions?.showLabel === false">{{ field.DisplayText }}</label>

		<p-dropdown
			*ngIf="field.UIControl === 'Dropdown'"
			[ngClass]="{ 'ng-invalid': control?.invalid, 'ng-dirty': control?.invalid }"
			[options]="field.options"
			[formControl]="control"
			[style]="{ width: '100%' }"
			(onChange)="onChange($event)"
			[placeholder]="fieldOptions.label || field.DisplayText"
			[showClear]="field.UIOptions?.ShowClearButton"
			[filter]="field.UIOptions?.ShowFilter"
			appendTo="body"
			[optionLabel]="field.UIOptions && field.UIOptions['optionLabel'] ? field.UIOptions['optionLabel'] : 'label'"
			[optionValue]="field.UIOptions && field.UIOptions['optionValue'] ? field.UIOptions['optionValue'] : 'value'"
			(onFilter)="field.UIOptions?.LoadFromServer ? onServerFilter($event) : null"
			(onShow)="field.UIOptions?.LoadFromServer ? filterOptions($event) : null"
		>
		</p-dropdown>

		<ng-container *ngIf="field.UIControl === 'MultiSelect'">
			<p-multiSelect
				[ngClass]="{ 'ng-invalid': control.invalid, 'ng-dirty': control.invalid }"
				[options]="field.options"
				[formControl]="control"
				[style]="{ width: '100%' }"
				[maxSelectedLabels]="10"
				[optionLabel]="field.UIOptions?.OptionLabel"
				[dataKey]="field.UIOptions?.OptionValue"
				(onChange)="onChange($event)"
				[placeholder]="fieldOptions.label"
				[showClear]="field.UIOptions?.ShowClearButton"
				[filter]="!useServerFilter && field.UIOptions?.ShowFilter"
				[display]="field.UIOptions?.Display || 'chip'"
				[showToggleAll]="false"
				[resetFilterOnHide]="true"
				appendTo="body"
				(onPanelShow)="useServerFilter ? onMultiSelectPanelShow() : null"
				(onPanelHide)="useServerFilter ? onMultiSelectPanelHide() : null"
			>
				<ng-container *ngIf="useServerFilter">
					<ng-template pTemplate="header">
						<div class="p-multiselect-filter-container server-multiselect-filter">
							<input
								type="text"
								class="p-multiselect-filter p-inputtext p-component"
								[ngModel]="serverFilterText"
								(ngModelChange)="onServerFilterTextChange($event)"
								[placeholder]="field.UIOptions?.placeholder || 'Search'"
								(click)="$event.stopPropagation()"
								(keydown)="$event.stopPropagation()"
							/>
							<span class="p-multiselect-filter-icon pi pi-search"></span>
						</div>
					</ng-template>
				</ng-container>
			</p-multiSelect>
		</ng-container>

		<p-autoComplete
			*ngIf="field.UIControl === 'Autocomplete'"
			[formControl]="control"
			[suggestions]="field.options"
			[dropdown]="true"
			(completeMethod)="onServerFilter($event)"
			[field]="field.UIOptions['field'] ? field.UIOptions['field'] : 'name'"
			[size]="350"
			[dataKey]="field.UIOptions['dataKey'] ? field.UIOptions['dataKey'] : 'id'"
			(onSelect)="onSelect($event)"
			(onClear)="onClear($event)"
			[forceSelection]="true"
			[showClear]="true"
			[placeholder]="fieldOptions.label ? 'Type to search a' + fieldOptions.label : 'Type to search'"
		>
		</p-autoComplete>
	</div>
</ng-container>
